import React from 'react'
import "./rules.css";
import downloadIcon from "../../images/downloadIcon.png"
import zajecarskoPravila2026 from "../../assets/zajecarskoPravila2026.pdf"

const Rules = () => {


    const handleDownload = () => {
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = zajecarskoPravila2026;  // Replace with the path to your Word file
        link.download = 'zajecarskoPravila2026.pdf';  // Optional: specify the name of the file
        link.click();  // Trigger the download
    }


    return (
        <div className="content questionsAnswers rulesPage">

            <div className="titleMobileDisplay">
                Правила  <br className="mobileDisplay" />
                наградне игре  <br className="mobileDisplay" />
                „Зајечарско части”:
            </div>

            <div className="qa">
                <div className="item">
                    <div className="answer notPadding">На основу Закона о играма на срећу (<i>“Сл. гласник РС”, бр. 18/2020 и 94/2024</i>),
                        Правилника о ближим условима, односно садржини правила игара на срећу (<i>“Сл. гласник РС”, бр. 31/2025</i>)
                        и Одлуке организатора бр. HEI/2026/325 од 23.02.2026. године, организатор доноси
                    </div>

                    <br />

                    <div className="question headTitle">Правила наградне игре у роби и услугама</div>

                    <div className="question headTitle">“Зајечарско части” </div>
                </div>

                <div className="item">
                    <div className="question">ОРГАНИЗАТОР</div>
                    <div className="order">ЧЛАН 1.</div>
                    <div className="answer">Организатор наградне игре у роби и услугама под називом “<b>Зајечарско части</b>”
                        (у даљем тексту: <b>Наградна игра</b>) је HEINEKEN Srbija doo Zaječar, Железничка 2, 19000 Зајечар, Република Србија, матични број: 20309288,
                        ПИБ: 105093995 (у даљем тексту: <b>Организатор</b>), а на основу одлуке Организатора бр. HEI/2026/325 од 23.02.2026. године.
                        Ова правила (у даљем тексту: <b>Правила</b>) су обавезујућа за све учеснике у Наградној игри.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ЗВАНИЧНИ НАЗИВ НАГРАДНЕ ИГРЕ</div>
                    <div className="order">ЧЛАН 2.</div>
                    <div className="answer">
                        Званични назив Наградне игре гласи “<b>Зајечарско части</b> ”.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ТЕРИТОРИЈА</div>
                    <div className="order">ЧЛАН 3.</div>
                    <div className="answer">
                        Наградна игра ће бити организована на територији Републике Србије.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ТРАЈАЊЕ И СТУПАЊЕ НА СНАГУ ПРАВИЛА НАГРАДНЕ ИГРЕ</div>
                    <div className="order">ЧЛАН 4.</div>
                    <div className="answer">
                        Наградна игра ће почети 06. априла 2026. године  у 00:00 часова и трајаће до 17. маја 2026. године 23:59 часова.
                        <br /> <br />
                        Ова Правила ступају на снагу даном добијања сагласности од стране Управе за игре на срећу.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ПРОМОТИВНА ПАКОВАЊА И СВРХА ОРГАНИЗОВАЊА</div>
                    <div className="order">ЧЛАН 5.</div>
                    <div className="answer">
                        Сврха организовања Наградне игре је промоција производа бренда Зајечарско описаних у наставку овог члана,
                        а који су обележени промотивним етикетама и промотивним затварачима и то: <br />

                        - Зајечарско пиво паковано у лименку од 0,5 литара (у даљем тексту: <b>КЕН</b>) са промотивним затварачима сребрно-црвене боје <br />
                        - Зајечарско пиво паковано у стаклену повратну боцу од 0,5 литара (у даљем тексту: <b>РГБ</b>) са промотивним затварачима црвено-беле боје <br />
                        - Зајечарско пиво паковано у стаклену неповратну боцу од 0,33 литра (у даљем тексту: <b>ОВБ</b>) са промотивним затварачима црвено-беле боје <br /> <br />

                        (у даљем тексту: <b>Промотивна паковања</b>). <br /> <br />

                        Сва Промотивна паковања имају на унутрашњој страни промотивног затварача одштампан јединствени осмознаменски алфанумерички
                        код (у даљем тексту: „<b>Код</b>“) и обележени су промотивним етикетама путем којих Организатор комуницира основне детаље Наградне игре.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ПРАВО УЧЕШЋА</div>
                    <div className="order">ЧЛАН 6.</div>
                    <div className="answer">
                        Сва пунолетна лица са пребивалиштем у Републици Србији имају право да учествују у Наградној игри, изузев лица
                        запослених код Организатора, маркетиншких агенција које је Организатор ангажовао у промоцији Наградне игре, као и
                        чланова њихових најужих породица (супружници, деца, те родитељи и рођена браћа и сестре уколико са њима живе у заједници). <br /> <br />

                        Организатор задржава право да, по сопственом нахођењу, изврши мере провере горе наведених чињеница.
                    </div>
                </div>

                <div className="item">
                    <div className="question">МЕХАНИЗАМ УЧЕСТВОВАЊА У НАГРАДНОЈ ИГРИ</div>
                    <div className="order">ЧЛАН 7.</div>
                    <div className="answer">
                        Након што потрошач купи  било које Промотивно паковање у продајним
                        и угоститељским објектима у периоду од 06.04.2026. године до 17.05.2026. године и
                        пронађе Kод испод затварача на Промотивном паковању, потребно је да исти пошаље у исправном формату путем:  <br /> <br />

                        - СМС поруке на број 6600  - слањем ове поруке потрошач прихвата правила Наградне игре и потврђује да има 18 или више година, или <br />
                        - путем web странице <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>  тако што ће унети датум свог рођења и алгоритам ће аутоматски израчунати да ли учесник
                        има 18 или више година. Уколико је учесник пунолетан, може унети  Код у предвиђено поље, након чега је потребно
                        да притисне дугме „ПОШАЉИ“. Изнад дугмета „ПОШАЉИ“ стајаће поље које ће потрошач моћи да обележи,
                        а поред поља ће стајати текст “Прихватам правила наградне игре''. Унос Кода не може да се комплетира уколико поред
                        поруке у одговарајућем формату учесник не остави и број телефона и електронску адресу који ће служити за његову идентификацију.
                        Учесници су сами одговорни да осигурају да број и електронска адреса које региструју путем web странице буду исправни,
                        те Организатор не сноси никакву одговорност у случају да је дошло до грешке током регистровања броја услед чега награда
                        не може бити додељена, уручена или шта слично. У случају да учесник, који је унео све горе наведене податке, не освоји
                        ниједну награду, сви унети подаци ће бити обрисани одмах по завршетку Наградне игре. <br /> <br />

                        Слањем Кода потрошач постаје учесник Наградне игре. Учесник (слањем Кода) учествује у инстант извлачењу за једну од
                        награда описаних у овим Правилима. Поруке које су послате у другачијој форми од оне која је наведена или на било који
                        начин садржи неправилно унет Код, неће се сматрати исправним и неће учествовати у извлачењу. <br /> <br />

                        Одмах након слања исправног Кода на горе објашњен начин, учесник добија повратну информацију поруком,
                        да ли је добио неку од награда или не и то: <br /> <br />

                        - путем СМС поруке ако је Код послао СМС-ом или <br />
                        - кроз обавештајно поље на web страници&nbsp;<a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a> , ако је Код послао путем web странице. <br /> <br />

                        СМС порука се наплаћује учеснику Наградне игре по цени основне поруке оператoра и то: <br /> <br />

                        - за кориснике МТС мобилне мреже: 3,6 дин (у цену је урачунат ПДВ) <br />
                        - за кориснике Yettel мобилне мреже: 4,9 дин (у цену је урачунат ПДВ) <br />
                        - за кориснике A1 мобилне мреже: 3,48  дин (у цену је урачунат ПДВ) <br />
                        - за кориснике Globaltel мобилне мреже: 3,48  дин (у цену је урачунат ПДВ) <br /> <br />

                        Оператoри задржавају право на промену стандардне цене СМС поруке која се тарифира крајњем кориснику, сходно својој комерцијалној политици.
                        Организатор не одговара за евентуалну промену наведених цена која настане након објављивања ових Правила. <br /> <br />

                        У случају да учесник није освојио ниједну награду, добиће повратну поруку: <br /> <br />
                        „Поштовани, нисте освојили ниједну награду. Желимо Вам више среће следећи пут!“ <br /> <br />
                        У случају да је учесник послао неисправан Код, добиће повратну поруку: <br /> <br />
                        „Поштовани, код који сте унели је неисправан. Молимо Вас, контактирајте наш контакт центар или покушајте поново.“ <br /> <br />
                        У случају да је учесник послао Код који је већ искоришћен, добиће повратну поруку: <br /> <br />
                        „Поштовани, код који сте унели је већ искоришћен. У току трајања наградне игре, један исти код се не може користити више пута.“ <br /> <br />
                        Када је учесник освојио неку од награда, добија и информацију коју награду је освојио
                        (Сет за роштиљ, Кухињски фрижидер, Ваучер од 2000 eвра за опремање кухиње, аутомобил ШКОДА ОКТАВИЈА): <br /> <br />

                        „Честитамо! Освојили сте награду – Сет за роштиљ. Бићете контактирани у наредна 3 радна дана ради узимања података.
                        Сачувајте свој добитни затварач.“ – у случају да је освојена Сет за роштиљ . <br /> <br />

                        „Честитамо! Освојили сте награду - Кухињски фрижидер. Бићете контактирани у наредна 3 радна дана ради узимања података.
                        Сачувајте свој добитни затварач.“ – у случају да је освојен Кухињски фрижидер. <br /> <br />

                        „Честитамо! Освојили сте награду – Ваучер за опремање кухиње. Бићете контактирани у наредна 3 радна дана ради узимања података.
                        Сачувајте свој добитни затварач .“ – у случају да је освојен Ваучер за опремање кухиње. <br /> <br />

                        „Честитамо! Освојили сте награду – аутомобил ШКОДА ОКТАВИЈА. Бићете контактирани у наредна 3 радна дана ради узимања података.
                        Сачувајте свој добитни затварач .“ – у случају да је освојен аутомобил ШКОДА ОКТАВИЈА. <br /> <br />

                        Награде које се деле учесницима у Наградној игри, а које су описане у члану 8. ових Правила, ће бити додељиване по следећој динамици:
                        <br /> <br />

                        <div className="question">НАГРАДЕ НА САТ ВРЕМЕНА</div>

                        Награда – Сет за роштиљ се извлачи током сваких сат времена за читаво време трајања Наградне игре. Компјутерски код/алгоритам у
                        периодима од по сат времена (од 00:00 до 00:59, затим од 01:00 до 01:59 итд.) насумично одређује тренутак доделе
                        ове награде. Учесник који први пошаље исправан Код након тог насумично одређеног тренутка осваја награду. Последњи
                        тренутак када награда може бити извучена је 17.05.2026. године у 23:59, односно, последњи период када
                        алгоритам насумично одређује тренутак доделе ове награде је 17.05.2026. године од 23:00  до 23:59. <br /> <br />

                        <div className="question">НАГРАДЕ НА ЈЕДАН ДАН</div>

                        Награда – Кухињски фрижидер се извлачи једном дневно, сваког дана током читавог трајања Наградне игре. Компјутерски код/алгоритам у
                        периодима од по један дан (од 00:00 до 23:59) насумично одређује тренутак доделе ове награде. Учесник који први
                        пошаље исправан Код након тог насумично одређеног тренутка осваја награду. Последњи тренутак када
                        награда може бити извучена је 17.05.2026. године у 23:59, односно, последњи период када алгоритам
                        насумично одређује тренутак доделе ове награде је 17.05.2026. године од 00:00 до 23:59. <br /> <br />

                        <div className="question">НАГРАДЕ НА СЕДАМ ДАНА</div>

                        Награда – Ваучер од 2000 eвра за опремање кухиње се извлачи у циклусима од по седам дана током читавог трајања Наградне игре.
                        Компјутерски код/алгоритам у периодима од по седам дана (од првог дана у 00:00 до седмог дана у 23:59) насумично
                        одређује тренутак доделе ове награде. Учесник који први пошаље исправан Код након тог насумично одређеног тренутка осваја награду.
                        <br /> <br />

                        Циклуси су распоређени на следећи начин: <br /> <br />

                        - <u>Први циклус од седам дана:</u> од 06.04. до 12.04. <br />
                        - <u>Други циклус од седам дана:</u> од 13.04. до 19.04. <br />
                        - <u>Трећи циклус од седам дана:</u> од 20.04. до 26.04. <br />
                        - <u>Четврти циклус од седам дана:</u> од 27.04. до 03.05. <br />
                        - <u>Пети циклус од седам дана:</u> од 04.05. до 10.05. <br />
                        - <u>Шести циклус од седам дана:</u> од 11.05. до 17.05. <br />  <br />

                        Последњи тренутак када награда може бити извучена је 17.05.2026. године у 23:59, односно, последњи период када алгоритам
                        насумично одређује тренутак доделе ове награде је од 11.05. 00:00  до 17.05.2026. године у 23:59. <br /> <br />

                        <div className="question">НАГРАДЕ НА ЧЕТРНАЕСТ ДАНА</div>

                        Награда – аутомобил ШКОДА ОКТАВИЈА се извлачи у циклусима од по четрнаест дана током читавог трајања Наградне игре. Компјутерски
                        код/алгоритам у периодима од по четрнаест дана (од првог дана у 00:00 до четрнаестог дана у 23:59) насумично одређује
                        тренутак доделе ове награде. Учесник који први пошаље исправан Код након тог насумично одређеног тренутка осваја награду. <br /> <br />

                        Циклуси су распоређени на следећи начин: <br /> <br />

                        - <u>Први циклус од четрнаест дана:</u> од 06.04. до 19.04. <br />
                        - <u>Други циклус од четрнаест дана:</u> од 20.04. до 03.05. <br />
                        - <u>Трећи циклус од четрнаест дана:</u> од 04.05. до 17.05. <br /> <br />

                        Последњи тренутак када награда може бити извучена је 17.05.2026. године у 23:59, односно, последњи период када
                        алгоритам насумично одређује тренутак доделе ове награде је од 04.05.2026. 00:00 до 17.05.2026 у 23:59. <br /> <br />

                        <b>Једном послат Код се више не може користити без обзира на то да ли је тим Кодом учесник освојио неку од наведених награда или не.</b> <br /> <br />

                        Нема ограничења у броју послатих Кодова по учеснику, нити у погледу броја награда које се деле на дневном
                        нивоу (на сат времена и на један дан) коју један телефонски број може да освоји. Током трајања Наградне
                        игре један учесник може освојити само једну награду која се дели на седам дана и само једну награду
                        која се дели на четрнаест дана. Ове две награде се међусобно не искључују и један учесник може освојити и
                        награду у циклусу од седам дана (Ваучер од 2000 eвра за опремање кухиње) и награду у циклусу од четрнаест
                        дана (аутомобил ШКОДА ОКТАВИЈА). У случају да један учесник оствари право на две или више награда у
                        циклусу од седам дана или оствари право на две или више награда у циклусу од четрнаест дана
                        (било да је Код послао са истог или са различитих бројева телефона), другу награду у
                        циклусу од седам или у циклусу од четрнаест дана неће добити и та награда остаје недодељена.  <br /> <br />

                        Сваки учесник може за време трајања наградне игре послати неограничен број СМС порука на број 6600
                        или аплицирати путем wеb-а на сајту <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>. <br /> <br />

                        Учесници се у сваком тренутку, путем wеb странице <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a> могу информисати да ли је у одређеном циклусу од седам
                        или четрнаест дана већ додељена награда. Обавештење о додељеним наградама у циклусу од седам или четрнаест дана ће бити постављено
                        на поменутој web страници најкасније до краја дана у ком је додељена награда из датог циклуса. <br /> <br />

                        Добитници су дужни да чувају затвараче са Кодовима којима су освојене награде, до уручења награда и предају их приликом
                        преузимања награда лицима која им награде уручују, на захтев тог лица које уручује награду.
                        У случају да лице које уручује награду од добитника затражи затварач са горе поменутим Кодом, а
                        добитник нема тај затварач, такав добитник ће бити дисквалификован, а награда ће остати недодељена. <br /> <br />

                        Након што је добио поруку којом је обавештен да је добио одређену награду, добитника ће најкасније у року од 3 радна дана
                        контактирати контакт центар, који ће од добитника затражити основне личне податке.
                        Тек након што саопшти потребне личне податке учесник стиче својство добитника.
                        Лични подаци који ће том приликом бити прикупљани од добитника су: име и презиме, адреса и ЈМБГ.
                        У случају да се, приликом идентификације добитника, утврди да је добитни Код послало малолетно лице,
                        такво лице ће бити моментално дисквалификовано и неће имати право на преузимање награде, а та награда ће остати недодељена.
                        Организатор ће покушати да добитника контактира више пута на неки од регистрованих контаката
                        (уколико је недоступан, није у могућности да разговара и сл.), али се обавезује на најмање два таква покушаја. <br /> <br />

                        Уколико у било ком периоду доделе награда (један сат, један дан, циклус од седам дана или циклус од четрнаест дана),
                        не буде додељена награда одређеног типа предвиђеног за тај период услед тога што није послат ниједан исправан
                        Код, та награда се преноси у следећи период, тако да ће у том следећем периоду бити извучен и добитник за претходни период.
                        Чим се на горе описан начин утврди први учесник који је послао исправан Код, том лицу биће додељена прва по реду недодељена награда.
                        По истом принципу се свим следећим учесницима који су послали исправан Код додељују награде по истом редоследу по
                        ком их је алгоритам одредио, све док се не поделе све недодељене награде.
                        Након тога, награде настављају да се деле редовном динамиком, како је описано у овим Правилима. <br /> <br />

                        <b><u>Пример:</u></b> У периоду од 15:00 до 16:59 није послат ниједан исправан Код.
                        Иако у овим периодима алгоритам одређује период доделе награда, а како није послат ниједан исправан
                        Код, награде из два периода (по један Сет за роштиљ), остају недодељене
                        (прва награда је требала да буде додељена у периоду извлачења који је алгоритам одредио од 15:00 до 15:59, а
                        друга у периоду извлачења који је алгоритам одредио од 16:00 до 16:59). Ове награде остају недодељене све
                        док неко од учесника не пошаље исправне Кодове у наредном периоду извлачења. <br /> <br />

                        У трећем периоду извлачења у периоду од 17:00 до 17:59 алгоритам насумично одреди да у 17:15 треба да додели
                        награду Ваучер од 2000 eвра за опремање кухиње. У 17:20 учесник пошаље први исправан Код. Како
                        је ово први послати исправан Код после горе два наведена периода у коме није било добитника
                        (дакле, до тада нико није послао исправан Код у периоду од 15:00 до 16:59), овај учесник
                        добија прву недодељену награду, односно награду која је требала да се додели у периоду одабраном
                        насумично у времену од 15:00 до 15:59. Одмах након тога алгоритам првом следећем исправном Коду
                        додељује прву следећу недодељену награду из другог периода, односно награду која је требала да се додели
                        у периоду одабраном насумично у времену од 16:00 до 16:59  и тако све док се послати исправни Кодови
                        не исцрпе доделом до тада недодељених награда из претходног и тренутног периода извлачења.  <br /> <br />

                        Исти принцип приоритета у времену се примењује у додели и недодељених награда
                        другог типа, уз примену одговарајућих временских периода.  <br /> <br />

                        Уколико број послатих исправних Кодова буде мањи од укупног броја награда,
                        све награде које преостану ће бити недодељене и остају својина Организатора.

                    </div>
                </div>


                <div className="item">
                    <div className="question">ОПИС НАГРАДА</div>
                    <div className="order">ЧЛАН 8.</div>
                    <div className="answer">
                        Награде које се деле учесницима у Наградној игри су: <br /> <br />

                        1. Награда које се додељују сваких сат времена – Сет за роштиљ. <br /> Сет за роштиљ се састоји из:   <br />

                        ▪ Три роштиљска елемента: <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;    -   хватаљка за роштиљ, <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;    -	виљушка за роштиљ и <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;    -	шпатула за роштиљ <br />
                        ▪ Футроле за роштиљске елементе <br /> <br />

                        2. Награда која се додељује сваког дана – Кухињски фрижидер <br /> <br />

                        Самостојећи кухињски фрижидер са замрзивачем робне марке LG. <br /> <br />

                        Модел GBV22L0EPY <br />
                        Висина : 203цм <br />
                        Ширина : 59,5цм <br />
                        Дубина : 68,2цм <br />
                        Боја : Сива <br />
                        Енергетски разред : Е <br />
                        Укупна запремина : 387 l <br />
                        Запремина фрижидера : 277 l <br />
                        Запремина замрзивача/коморе : 110 l <br /> <br />


                        3. Награда која се додељује у циклусу од седам дана – Ваучер од 2000 eвра за опремање кухиње који се може искористити до
                        31.12.2026. године. Овај ваучер се може искористити за куповину робе у објектима
                        Техноманија, Техномедиа и Виторог. Целокупна понуда се може видети на сајту:
                        <a href="https://www.giftoncard.eu/zajecarsko-nagradna-igra" target="_blank"> https://www.giftoncard.eu/zajecarsko-nagradna-igra</a>.
                        Ваучер се може користити за више различитих куповина до укупног износа од 2000 евра.
                        Уколико куповина прелази наведени износ, добитници сносе разлику. <br /> <br />

                        4. Награда која се додељује у циклусу од четрнаест дана - аутомобил марке ШКОДА, модел ОКТАВИЈА са „Selection“ опремом.  <br /> <br />

                        У сваком од наведених периода ће бити додељена по једна награда.  <br /> <br />

                        Укупан број награда који ће учесницима бити подељен је: <br /> <br />

                        1. 1008 комада Сетова за роштиљ, <br />
                        2. 42 комада Кухињских фрижидера, <br />
                        3. 6 комада Ваучера од 2000 eвра за опремање кухиње, <br />
                        4. 3 комада аутомобила ШКОДА ОКТАВИЈА; <br /> <br />

                        Награде се не могу заменити за новац. <br /> <br />

                        Награде се не могу преносити на друга лица. <br /> <br />

                        У току трајања Наградне игре, један учесник може освојити неограничен број награда под редним бројем
                        1 и 2 (Сет за роштиљ и Кухињски фрижидер). У току трајања Наградне игре, један учесник може освојити највише један
                        Ваучер од 2000 eвра за опремање кухиње и један аутомобил ШКОДА ОКТАВИЈА, наведени као награде
                        под редним бројем 3 и 4. У случају да један учесник оствари право на две или више награда под редним
                        бројем 3, односно, у циклусу од седам дана или оствари право на две или више награда под редним бројем 4, односно,  у циклусу
                        од четрнаест дана (било да је Код послао са истог или са различитих бројева телефона), другу награду
                        у циклусу од седам или у циклусу од четрнаест дана неће добити и та награда остаје недодељена.

                    </div>
                </div>

                <div className="item">
                    <div className="question">ВРЕДНОСТ НАГРАДА</div>
                    <div className="order">ЧЛАН 9.</div>
                    <div className="answer">

                        <table border="1">
                            <tr>
                                <th>Тип награде</th>
                                <th>Опис</th>
                                <th>Укупан број награда</th>
                                <th>Појединачна вредност награде (РСД)</th>
                                <th>Укупна вредност награде (РСД)</th>
                            </tr>
                            <tr>
                                <th>Сет за роштиљ</th>
                                <th>Састоји се од футроле са алатом за роштиљ (хватаљка, виљушка и шпатула за роштиљ)</th>
                                <th>1.008</th>
                                <td>664,80</td>
                                <td>670.118,40</td>
                            </tr>
                            <tr>
                                <th>Кухињски фрижидер</th>
                                <th>
                                    Самостојећи кухињски фрижидер са замрзивачем доле марке LG. <br />
                                    Модел GBV22L0EPY <br />
                                    Висина : 203цм <br />
                                    Ширина : 59,5цм <br />
                                    Боја : Сива <br />
                                    Енергетски разред: E

                                </th>
                                <th>42</th>
                                <td>
                                    65.016,00
                                </td>
                                <td>2.730.672,00</td>
                            </tr>
                            <tr>
                                <th>Ваучер од 2000 eвра за опремање кухиње</th>
                                <th>Ваучер у износу од 2000 евра за куповину у мрежи радњи Техноманија, Техномедиа и Виторог.</th>
                                <th>6</th>
                                <td>
                                    234.780,60
                                </td>
                                <td>1.408.683,60</td>
                            </tr>
                            <tr>
                                <th>ШКОДА ОКТАВИЈА</th>
                                <th>Аутомобил марке Шкода ОКТАВИЈА са „Selection“ опремом</th>
                                <th>3</th>
                                <td>2.975.506,32</td>
                                <td>8.926.518,96</td>
                            </tr>
                            <tr>
                                <th>Укупна вредност наградног фонда</th>
                                <th></th>
                                <th></th>
                                <td></td>
                                <td>13.735.992,96</td>
                            </tr>
                        </table>

                        <span>*ПДВ урачунат у цену</span>

                        <br /> <br />
                        Горе наведене вредности награда су обрачунате на следећи начин: <br /> <br />

                        1. <b><u>Сет за роштиљ:</u></b> <br /> <br />

                    &nbsp;&nbsp;&nbsp;&nbsp;    -	Награда се састоји од футроле са три роштиљска елемента
                        (хватаљка за роштиљ, виљушка за роштиљ и шпатула за роштиљ). Вредност једног сета
                        је 554,00 динара без урачунатог ПДВ-а, односно <b>664,80 динара</b> са урачунатим ПДВ-ом.
                        Укупна вредност свих 1008 сетова износи 1008 x 664,80 = <b>670.118,40 динара</b>
                        са урачунатим ПДВ-ом. <br /> <br />


                        2. <b> <u>Кухињски фрижидер:</u></b> <br /> <br />

                   &nbsp;&nbsp;&nbsp;&nbsp;     -	Самостојећи кухињски фрижидер са замрзивачем, робне марке LG, модел GBV22L0EPY.
                        Висина кухињског фрижидера износи 203цм, а ширина 59,50цм. Боја кухињског
                        фрижидера је сива. Енергетски разред уређаја: Е. Вредност једног кухињског
                        фрижидера износи 54.180,00 динара без ПДВ-а, односно 65.016,00 динара са
                        урачунатим ПДВ-ом, дакле укупно 65.016,00 x 42 = <b>2.730.672,00 динара</b> са урачунатим ПДВ-ом.
                        <br /> <br />


                        3. <b><u>Ваучер од 2000 eвра за опремање кухиње:</u></b> <br /> <br />

                   &nbsp;&nbsp;&nbsp;&nbsp;     -	Тржишна вредност једног Ваучера износи 2.000,00 евра (у динарској проитввредности),
                        односно <b>234.780,60 динара</b> према средњем курсу на дан понуде 20.01.2026.
                        године који износи 117,3903.  Укупна вредност свих 6 Ваучера од 2000,00 евра
                        за куповину износи 6 x 234.780,60 = <b>1.408.683,60.</b> <br /> <br />


                        4. <b><u>Шкода Октавија</u>:</b> <br /> <br />

                   &nbsp;&nbsp;&nbsp;&nbsp;   -	Цена појединачног аутомобила износи 25.356,00 евра са урачунатим ПДВ-ом и царином. 
                      Средњи курс на дан понуде 16.01.2026. године је износио 117,3492. 
                      Вредност једног аутомобила је у складу са тим 2.975.506,32 са урачунатим ПДВ-ом и царином. 
                      Вредност укупно 3 аутомобила са урачунатим ПДВ-ом и царином 
                      износи 3 x 2.975.506,32 = <b>8.926.518,96 динара</b> са урачунатим ПДВ-ом.

                    </div>
                </div>

                <div className="item">
                    <div className="question">ОБЈАВЉИВАЊЕ ДОБИТНИХ КОДОВА</div>
                    <div className="order">ЧЛАН 10.</div>
                    <div className="answer">
                        Организатор ће на сваких седам дана у току трајања Наградне игре правити пресек додељених награда у том периоду
                        и на интернет страници Организатора: <a href="https://www.zajecarskoigra.rs/dobitnici" target="_blank">www.zajecarskoigra.rs/dobitnici</a> објавити све добитне
                        Кодове у том периоду заједно са наградама које су власници добитних Кодова освојили.
                        Организатор неће објављивати податке о личности добитника, а у складу са Законом о заштити података о личности.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ПРЕДАЈА НАГРАДА И РОК ЗА КОРИШЋЕЊЕ</div>
                    <div className="order">ЧЛАН 11.</div>
                    <div className="answer">
                        Поклони Сет за роштиљ, Кухињски фрижидер и Ваучер од 2000 eвра за опремање кухиње ће бити достављени добитницима путем курирске
                        службе на адресу коју су доставили Организатору, a у року од 90 дана од дана добијања награде. Приликом
                        предаје награда добитник је дужан да потпише документ којим потврђује да је награду преузео
                        и остави као доказ свој потпис и број личне карте. Уколико курир не затекне добитника или
                        пунолетног члана породичног домаћинства добитника чији су подаци достављени Организатору, упутиће
                        добитнику СМС или позив са обавештењем о следећем термину испоруке. У случају поновне неуспеле испоруке
                        добитник ће на исти начин бити обавештен где може да преузме награду. Уколико добитник пропусти да награду
                        преузме у року од 30 дана од дана достављања обавештења губи право на исту и награда остаје недодељена. <br /> <br />

                        Добитницима са пребивалиштем на територији АП Косово и Метохија, награде ће бити уручене у договору са самим добитницима. <br /> <br />

                        Организатор ће добитнику награде ШКОДА ОКТАВИЈА организовати уручење кључева у Зајечарској пивари најкасније у
                        року од 120 дана након завршетка Наградне игре уз обавезно присуство тренингу за одговорну конзумацију. <br /> <br />

                        У случају примедби на квалитет и употребну вредност награда, добитници ће се обратити правним лицима која
                        су награде обезбедили у складу са прописима о заштити потрошача. Одговорност Организатора
                        према добитницима у вези са квалитетом награда престаје након чина испоруке/предаје добијене
                        награде која одговара опису награде из ових Правила. <br /> <br />

                        Организатор задржава право да дисквалификује учеснике који не поштују Правила, или који су преваром или
                        на било који други недозвољен начин или начин који се противи духу сврхе Наградне игре,
                        дошли у посед затварача са добитним Кодовима. <br /> <br />

                        Коришћење било какве врсте компјутерског кода, вируса, или било чега што може ометати, онемогућити, нанети штету,
                        или злоупотребити учествовање у Наградној игри је забрањено. Такви поступци представљају основ за елиминацију учесника.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ИЗВЕШТАВАЊЕ И КОМИСИЈА</div>
                    <div className="order">ЧЛАН 12.</div>
                    <div className="answer">
                        Организатор ће у року од 30 дана од завршетка Наградне игре доставити Управи за игре на срећу извештај о резултатима Наградне игре. <br /> <br />

                        Регуларност одвијања Наградне игре ће пратити комисија коју чине следећи запослени код Организатора: <br /> <br />

                        - Дарко Миловановић, Маркетинг менаџер, <br /> <br />
                        - Стефан Јовић, Менаџер групе брендова и   <br /> <br />
                        - Душан Вранић, Старији бренд менаџер.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ИСКЉУЧЕЊЕ ОДГОВОРНОСТИ</div>
                    <div className="order">ЧЛАН 13.</div>
                    <div className="answer">
                        За предају и коришћење награда гарантује Организатор. <br /> <br />

                        Евентуални спорови између учесника у вези са власништвом над затварачима Промотивних паковања, регистрованим профилима,
                        бројевима телефона или e-mail адресама, не утичу на принцип да ће Организатор доделити награду лицу
                        које Организатору буде поднело такав захтев у складу са одредбама ових Правила.
                        Организатор такође неће узети учешће у евентуалним споровима око власништва над затварачима
                        Промотивних паковања, бројевима телефона, регистрованим профилима, e-mail адресама или додељеним наградама.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ТРОШКОВИ</div>
                    <div className="order">ЧЛАН 14.</div>
                    <div className="answer">
                        Организатор неће сносити трошкове у вези са доделом награда осим трошкова на које се обавезао овим Правилима,
                        нити сносити или надокнадити трошкове учествовања у Наградној игри. Организатор ће сносити трошкове пореза на добитке од игара на срећу.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ДОСТУПНОСТ ПРАВИЛА</div>
                    <div className="order">ЧЛАН 15.</div>
                    <div className="answer">
                        За информације учесници могу позвати инфо-телефон 0800/003-337 радним данима од 09:00 до 20:00 часова,
                        а суботом од 09:00 до 15:00 часова, за време трајања Наградне игре. <br /> <br />

                        Правила се налазе на web страници <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a> и биће доступна током читавог периода трајања Наградне игре.
                    </div>
                </div>

                <div className="item">
                    <div className="question">СТУПАЊЕ НА СНАГУ И ОБЈАВЉИВАЊЕ ПРАВИЛА</div>
                    <div className="order">ЧЛАН 16.</div>
                    <div className="answer">
                        Правила Наградне игре ће бити објављена у најмање једном дневном листу који се дистрибуира на територији целе
                        Републике најкасније 8 дана пре отпочињања, истакнута на интернет страници <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a> и
                        делимично публикована на етикетама Промотивних паковања и на маркетиншком материјалу на продајним местима.
                    </div>
                </div>

                <div className="item">
                    <div className="question">СПОРОВИ</div>
                    <div className="order">ЧЛАН 17.</div>
                    <div className="answer">
                        Сваки спор између Организатора и било ког учесника Наградне игре, решаваће стварно надлежни суд у Београду.
                    </div>
                </div>

                <div className="item">
                    <div className="question">ЗАШТИТА ПОДАТАКА О ЛИЧНОСТИ</div>
                    <div className="order">ЧЛАН 18.</div>
                    <div className="answer">
                        Организатор као руковалац ће прикупљати и обрађивати податке о личности добитника награда искључиво за сврху коју
                        прописује члан 110 Закона о играма на срећу (<i>"Сл. гласник РС", бр. 18/2020 и 94/2024</i>) (у даљем тексту: <b>Закон о играма на срећу</b>).
                        Организатор ће водити базу података о лицима која су остварила добитак и држаће у тајности податке
                        о учесницима и њиховом учествовању у игри, укључујући и податке о њиховим добицима. <br /> <br />

                        Подаци из става 1. овог члана се неће уступати трећим лицима или јавно објављивати, осим у случају достављања
                        података која се врши за потребе спровођења Закона о играма на срећу и прописа којим се уређује
                        област спречавања прања новца и финансирања тероризма. <br /> <br />

                        Подаци о лицима из става 1. овог члана прикупљају се и обрађују у складу са Законом о заштити података о
                        личности (<i>"Сл. гласник РС", бр. 87/2018</i>) (у даљем тексту: <b>Закон о заштити података о личности</b>).
                        Основ за прикупљање података о личности учесника је њихов пристанак сходно члану 15 Закона
                        о заштити података о личности и сматраће се да је свако лице које учествује у Наградној
                        игри дало свој пристанак за обраду података о личности за ниже наведене сврхе. <br /> <br />

                        Сврха обраде података о личности учесника је искључиво учествовање у Наградној игри, односно, спровођење
                        Наградне игре и додела награда. Подаци о личности учесника које Организатор обрађује неће бити коришћени за било коју другу сврху. <br /> <br />

                        Организатор ће чувати ове податке 5 година, сходно одредби члана 110 Закона о играма на срећу,
                        а у складу са Законом о заштити података о личности. Подаци учесника која нису освојили награде
                        се чувају искључиво за случај да учесник уложи приговор или притужбу и биће обрисани одмах по
                        завршетку Наградне игре. Сви подаци су заштићени и не могу им приступити неовлашћена лица. <br /> <br />

                        Ради ефикасног организовања и спровођења наградне игре, Организатор као руковалац има закључен Уговор
                        о обради података о личности у складу са чланом 45 Закона о заштити података
                        о личности са агенцијом PRIMA MEDIA DOO, BEOGRAD – VRAČAR, ул. Хаџи Мелентијева бр.78, 11000 Београд,
                        МБ: 20784580, ПИБ: 107343327, као обрађивачем података о личности. Организатор у целости одговара за
                        закониту обраду података о личности. Лични подаци добитника ће бити прослеђени и курирској служби искључиво ради доставе награда. <br /> <br />

                        У складу са чланом 26 Закона о заштити података о личности свако лице чије податке о личности обрађује
                        Организатор има право да затражи информације о обради тих података.  <br /> <br />

                        Поред наведеног, лица чији подаци о личности се обрађују имају право и да захтевају да се њихови нетачни подаци
                        о личности без одлагања исправе у складу са чланом 29 Закона о заштити података о личности, као и да
                        се у потпуности избришу, када су за то испуњени законски услови, у складу са чланом 30 истог закона. <br /> <br />

                        Сва лица чији се подаци о личности обрађују у сваком тренутку имају право да поднесу притужбу Поверенику за
                        информације од јавног значаја и заштиту података о личности уколико сматрају да су њихова права повређена. <br /> <br />

                        Добитници аутомобила ШКОДА ОКТАВИЈА ће можда бити фотографисани за сврху промоције бренда Зајечарско.
                        У том случају, биће им понуђен посебан документ – сагласност, чијим потписивањем пристају на употребу
                        њихових фотографија у горе наведене сврхе. Потписивање овог документа и пристанак на такву обраду података
                        о личности (фотографисање и коришћење фотографије за промотивне сврхе) је у потпуности добровољно и никако
                        не представља услов за добијање/преузимање награде. <br /> <br />

                        Контакт подаци лица за заштиту података о личности Организатора: <br />

                        Михаило Ђуричић, e-mail адреса: mihailo.djuricic@heineken.com
                    </div>
                </div>

                <div className="item">
                    <div className="question">ПРЕКИД НАГРАДНЕ ИГРЕ</div>
                    <div className="order">ЧЛАН 19.</div>
                    <div className="answer">
                        Наградна игра може бити прекинута у случају више силе (околности које Организатор није могао предвидети нити на њих утицати),
                        укључујући немогућност Организатора услед разлога који су независни у односу на његову вољу да води Наградну игру.
                        Организатор ће обавестити потрошаче о евентуалном прекиду Наградне игре и разлозима путем дневног листа који
                        се дистрибуира на територији целе Републике. У случају прекида из горе наведеног разлога, Организатор неће бити
                        у обавези да учесницима накнади било какве трошкове који се односе на учествовање у Наградној игри. <br /> <br /> <br />



                        <div className="lastRight" style={{ marginRight: '70px' }}><b>О Р Г А Н И З А Т О Р</b></div>

                        <br />

                        <div className="lastRight" style={{ marginRight: '20px' }}> <b>HEINEKEN SRBIJA DOO ZAJEČAR</b></div>

                        <br /> <br /> <br />

                        <div className="lastRight" style={{ marginRight: '20px' }}> Sobir Djaffar, директор</div>

                        <br /> <br /> <br />

                        <div className="lastRight" style={{ marginRight: '20px' }}> Марко Андрић, регистровани заступник</div>

                    </div>
                </div>

            </div>
            <div className='border'>
                <div className='download' onClick={handleDownload}>
                    <img src={downloadIcon} alt="download icon" />
                    Преузми Правила наградне игре Зајечарско части
                </div>
            </div>


        </div>
    )
}

export default Rules